import React, { useRef } from 'react'

// next components
import Link from 'next/link'

// styles
import styles from './index.module.scss'
import { getDisplayUserName } from 'utils/strings'
import { countDecimals, getBuyerName, getLocalDate, getOwnerName } from 'utils/helpers'
import ImageWithFoster from 'components/ImageWithFoster'

const ActivityAccordion = ({ data }) => {
  const buttonRefs = useRef<any>([])
  const openedRef = useRef<any | null>(null)
  const clickRecent = index => {
    const clickedButton = buttonRefs.current[index]
    if (clickedButton === openedRef.current) {
      openedRef.current = null
      return
    }
    if (Boolean(openedRef.current?.getAttribute('data-value'))) {
      openedRef.current?.click()
    }
    openedRef.current = clickedButton
  }
  const getUserName = item => {
    let user = ''
    switch (item.action_type) {
      case 'AuctionStarted':
      case 'AuctionCancelled':
      case 'ListingAdded':
      case 'ListingCancelled':
      case 'MasterEditionListingCreated':
      case 'MasterEditionListingCancelled':
      case 'MasterEditionListingUpdated':
      case 'MasterEditionPrintCreated':
      case 'ListingUpdated':
        user = getOwnerName(item)
        break
      case 'OfferMade':
      case 'OfferCancelled':
      case 'QuickBuy':
      case 'AuctionWon':
      case 'BidPlaced':
        user = getBuyerName(item)
        break
    }
    return user
  }

  const getActionType = item => {
    let type = ''
    let nftName = item.action_type === 'MasterEditionPrintCreated' ? getPrintAssetName(item) : item.asset_name
    let price = countDecimals(parseFloat(item.amount)) > 2 ? parseFloat(item.amount).toFixed(2) : item.amount
    switch (item.action_type) {
      case 'AuctionStarted':
        type = 'started an auction for ' + nftName + ' for ' + price + ' SOL'
        break
      case 'AuctionCancelled':
        type = 'canceled the auction for ' + nftName
        break
      case 'ListingAdded':
        type = 'listed ' + nftName + ' for ' + price + ' SOL'
        break
      case 'ListingCancelled':
        type = 'delisted ' + nftName
        break
      case 'OfferMade':
        type = 'placed a ' + price + ' offer on ' + nftName
        break
      case 'OfferCancelled':
        type = 'withdrew their offer for ' + nftName
        break
      case 'QuickBuy':
        type = 'purchased a ' + price + ' sol offer on ' + nftName
        break
      case 'AuctionWon':
        type = 'won the auction for ' + nftName + ' at ' + price + ' SOL'
        break
      case 'BidPlaced':
        type = 'bid ' + price + ' sol on ' + nftName
        break
      case 'MasterEditionListingCreated':
        type = 'listed ' + nftName + ' for ' + price + ' SOL'
        break
      case 'MasterEditionListingUpdated':
        type = 'updated the mint price for'
        break
      case 'MasterEditionPrintCreated':
        type = 'collected edition ' + getPrintAssetName(item) + ' for ' + price + ' SOL'
        break
      case 'MasterEditionListingCancelled':
        type = 'delisted ' + nftName
        break
      case 'ListingUpdated':
        type = 'listed ' + nftName + ' for ' + price + ' SOL'
        break
    }
    return type
  }

  const getActivityType = item => {
    let type = ''
    switch (item.action_type) {
      case 'AuctionStarted':
        type = 'Live'
        break
      case 'AuctionCancelled':
        type = 'Cancel'
        break
      case 'ListingAdded':
        type = 'List'
        break
      case 'ListingCancelled':
        type = 'Cancel'
        break
      case 'OfferMade':
        type = 'Offer'
        break
      case 'OfferCancelled':
        type = 'Cancel'
        break
      case 'QuickBuy':
        type = 'Buy'
        break
      case 'AuctionWon':
        type = 'Won'
        break
      case 'BidPlaced':
        type = 'Bid'
        break
      case 'MasterEditionListingCreated':
        type = 'List'
        break
      case 'MasterEditionListingUpdated':
        type = 'Update'
        break
      case 'MasterEditionPrintCreated':
        type = 'Buy'
        break
      case 'MasterEditionListingCancelled':
        type = 'Remove'
        break
      case 'ListingUpdated':
        type = 'Update'
        break
    }
    return type
  }

  const getPrintAssetName = item => {
    let edition = item.asset_name.slice(item.asset_name.indexOf('#'))
    edition = edition.slice(0, edition.indexOf(', (#'))
    return edition + ' of ' + item.asset_name.slice(0, item.asset_name.indexOf('#'))
  }

  return (
    <div className="w-full flex flex-wrap">
      {data.map((item, index) => (
        <div key={index} className={styles.row}>
          <div className={styles.date}>{getLocalDate(item.created_at)}</div>

          <div className="w-full flex justify-between items-center mt-[15px]">
            <div className="flex items-center gap-[15px]">
              <Link href={`/nft/${item.mint_address}`} passHref>
                <a>
                  <div className="w-[40px] h-[40px]">
                    <ImageWithFoster
                      src={item.asset_url}
                      className="w-full h-full object-cover rounded-[10px] cursor-pointer"
                    />
                  </div>
                </a>
              </Link>
              <div className="flex flex-col gap-[4px] justify-between">
                <Link href={`/${getUserName(item)}`} passHref>
                  <a>
                    <div className={styles.userName}>{getDisplayUserName(getUserName(item))}</div>
                  </a>
                </Link>
                <div className="flex">
                  <Link href={`/nft/${item.mint_address}`} passHref>
                    <a>
                      <div className={styles.text}>
                        {getActionType(item)}
                        {/* {item.action_type === 'MasterEditionPrintCreated' ? getPrintAssetName(item) : item.asset_name} */}
                        {/* {isAmountExistingForMobile(item.action_type) &&
                          ` for ${
                            countDecimals(parseFloat(item.amount)) > 2
                              ? parseFloat(item.amount).toFixed(2)
                              : item.amount
                          } SOL`} */}
                      </div>
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.border} />
        </div>
        // <div key={index} className="w-full flex flex-wrap">
        //   <Disclosure>
        //     {({ open }) => (
        //       <>
        //         <Disclosure.Button
        //           className={open ? styles.activeButton : styles.button}
        //           data-value={open}
        //           ref={ref => {
        //             buttonRefs.current[index] = ref
        //           }}
        //           onClick={() => clickRecent(index)}
        //         >
        //           <div className="flex items-center gap-x-4">
        //             <div className={styles.imageContainer}>
        //               <ImageWithFoster src={item.asset_url} className="w-full h-full rounded-[4px] object-cover" />
        //             </div>
        //             <div className="block">
        //               <div className={styles.subTitle}>
        //                 {item.action_type === 'MasterEditionPrintCreated'
        //                   ? item.asset_name.slice(0, item.asset_name.indexOf(', (#'))
        //                   : item.asset_name}
        //               </div>
        //               <div className={styles.subType}>{item.action_type.replace(/([A-Z])/g, ' $1').trim()}</div>
        //             </div>
        //           </div>
        //           <DownArrowIcon className={`${open ? 'rotate-180 transform' : ''} mt-1 mr-1`} />
        //         </Disclosure.Button>
        //         <Disclosure.Panel className={styles.panel}>
        //           <div className={styles.firstRow}>
        //             <div className="w-full flex justify-between">
        //               <div>
        //                 <div className="flex gap-[4px] mb-[5px]">
        //                   <div className={styles.title}>{getDisplayUserName(getUserName(item))}</div>
        //                   <div className={styles.text}>{getActionType(item)}</div>
        //                 </div>
        //                 <div className={styles.date}>{getLocalDate(item.created_at)}</div>
        //               </div>
        //               {item.action_type !== 'MasterEditionListingCancelled' && (
        //                 <div>
        //                   <div className="w-fit-content h-[22px] mb-[2px] flex flex-row justify-end items-center">
        //                     <SolanaLogoMobileIcon alt="" />
        //                     <div className={styles.userName}>&nbsp;{item.amount}</div>
        //                   </div>
        //                   <div className={styles.usdValue}>
        //                     ${item.amount === 0 ? '---' : (item.amount * solToUsdRate).toFixed(2)}
        //                   </div>
        //                 </div>
        //               )}
        //             </div>
        //           </div>
        //         </Disclosure.Panel>
        //       </>
        //     )}
        //   </Disclosure>
        // </div>
      ))}
    </div>
  )
}

export default ActivityAccordion
